var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftCardinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M29 63v-4q-8-14-8-16t2-6"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M30.621 37.018 15 37c-1.74 0-3-1.76-3-3.5V13.803C12 12.063 13.26 11 15 11h29.927C46.668 11 48 12.429 48 14.17v19.696C48 35.606 46.668 37 44.927 37H40"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "m23 27 4-4m4 4-4-4m0-4.457L20 16v9l7-2.35zm0 0L34 16v9l-7-2.35z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M13.355 20h6.158M27 11v26m7.395-17h13"
})), /*#__PURE__*/React.createElement("path", {
  d: "m29 45 3-4V31q0-4 4-4c4 0 4 1.333 4 4v10q3 6 3 9c0 3-1 5-3 9v4"
}))));
export default SvgGiftCardinline;